export const REQUEST_EVENT = 'zola/event/request_event';
export const RECEIVE_EVENT = 'zola/event/receive_event';
export const REQUEST_EVENTS = 'zola/event/request_events';
export const RECEIVE_EVENTS = 'zola/event/receive_events';
export const RECEIVE_EVENTS_BY_DATE = 'zola/event/receive_events_by_date';
export const SELECT_EVENT = 'zola/event/select_event';
export const SUGGESTED_ATTIRE_OPTIONS_REQUESTED = 'zola/event/suggested_attire_options_requested';
export const SUGGESTED_ATTIRE_OPTIONS_RECEIVED = 'zola/event/suggested_attire_options_received';
export const SUGGESTIONS_REQUESTED = 'zola/event/suggestions_requested';
export const SUGGESTIONS_RECEIVED = 'zola/event/suggestions_received';
export const REQUEST_EVENTS_RSVP_PAGE = 'zola/event/request_events_rsvp_page';
export const RECEIVE_EVENTS_RSVP_PAGE = 'zola/event/receive_events_rsvp_page';
export const RECEIVE_MIGRATION_EVENTS = 'zola/event/receive_migration_events';
export const REQUEST_MIGRATION_EVENTS = 'zola/event/request_migration_events';
export const BEGIN_MIGRATING = 'zola/event/begin_migrating';
export const FINISH_MIGRATING = 'zola/event/finish_migrating';



// WEBPACK FOOTER //
// ./src/actions/types/EventActionTypes.js